import script from "./ShippingDetailsTotalsV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShippingDetailsTotalsV2.vue?vue&type=script&setup=true&lang=ts"

import "./ShippingDetailsTotalsV2.vue?vue&type=style&index=0&id=7be5d3f6&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be5d3f6"]])

export default __exports__